import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Step,
  StepLabel,
  Stepper,
  Typography,
} from "@mui/material";
import { StepIconProps } from "@mui/material";
import { styled } from "@mui/system";
import check_mark from "./img/check_mark.svg";

export interface CustomStepIconProps extends StepIconProps {
  label: string;
  activeColor: string;
  inactiveColor: string;
  setActiveStep: (x: number) => void;
  completedSteps: number[];
  stepIndex: number;
  activeStep: number;
}

const CustomStepIconRoot = styled("div")<{ ownerState: { color: string } }>(
  ({ ownerState }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: ownerState.color,
  })
);

export const CustomStepIcon: React.FC<CustomStepIconProps> = ({
  label,
  activeColor,
  inactiveColor,
  setActiveStep,
  completedSteps,
  stepIndex,
  activeStep,
}) => {
  const completed = completedSteps.indexOf(stepIndex) !== -1;
  const active = stepIndex === activeStep;
  return (
    <button onClick={() => setActiveStep(stepIndex)} className="py-4">
      <div className="flex flex-row space-x-2">
        <CustomStepIconRoot
          ownerState={{
            color: active || completed ? activeColor : inactiveColor,
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
          >
            <circle
              cx="12"
              cy="12"
              r="12"
              fill={active || completed ? activeColor : inactiveColor}
            />
          </svg>
          {completed && <img src={check_mark} className="absolute" />}
        </CustomStepIconRoot>
        <h1 className="hidden font-code font-bold text-[#F5F5F5] lg:block">
          {label}
        </h1>
      </div>
    </button>
  );
};
